"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyFieldAbilityHandler = exports.EnergyFieldActorAbilityFactory = exports.EnergyFieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class EnergyFieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EnergyField;
        this.__typeName = "EnergyField";
    }
}
exports.EnergyFieldAbilityArgs = EnergyFieldAbilityArgs;
let EnergyFieldActorAbilityFactory = class EnergyFieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EnergyField", "AllEnemies", 3);
    }
};
EnergyFieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EnergyField")
], EnergyFieldActorAbilityFactory);
exports.EnergyFieldActorAbilityFactory = EnergyFieldActorAbilityFactory;
let EnergyFieldAbilityHandler = class EnergyFieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const sonicDamagePerTurn = (0, Random_1.random)(10, 20);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                path: "sin",
                type: "WhiteVaporBall",
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Sonic", 30)
                ]
            })),
            onHit(sequence, attack, damage, { targetId }) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.SonicPulseEffectArgs("Focus", 10),
                });
            }
        });
    }
};
EnergyFieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EnergyField)
], EnergyFieldAbilityHandler);
exports.EnergyFieldAbilityHandler = EnergyFieldAbilityHandler;
